module.exports = __webpack_public_path__ + "static/media/capital-factory.95d1aab1.svg";